import { always } from 'ramda';
/**
 * Always returns null.
 *
 * @func
 * @category Function
 *
 * @example
 *
 *        R_.alwaysNull() // null
 *
 * @sig a -> Object
 */

var alwaysNull = /*#__PURE__*/always(null);
export default alwaysNull;